export function SearchFilled({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        data-testid="search-filled-icon"
        width="1em"
        height="1em"
        viewBox="0 0 70 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.58301 34.0462C6.58301 19.1771 18.6722 7.08789 33.5413 7.08789C48.4105 7.08789 60.4997 19.1771 60.4997 34.0462C60.4997 48.9153 48.4105 61.0046 33.5413 61.0046C18.6722 61.0046 6.58301 48.9153 6.58301 34.0462ZM24.7913 41.3587H33.5413C35.1514 41.3587 36.4788 40.0313 36.4788 38.4212C36.4788 36.8112 35.1514 35.4837 33.5413 35.4837H24.7913C23.1813 35.4837 21.8538 36.8112 21.8538 38.4212C21.8538 40.0313 23.1813 41.3587 24.7913 41.3587ZM24.7913 32.6087H42.2913C43.9014 32.6087 45.2288 31.2813 45.2288 29.6712C45.2288 28.0612 43.9014 26.7337 42.2913 26.7337H24.7913C23.1813 26.7337 21.8538 28.0612 21.8538 29.6712C21.8538 31.2813 23.1813 32.6087 24.7913 32.6087Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M62.1264 63.9171C61.7898 63.9171 61.4588 63.7847 61.2276 63.5535L55.8026 58.1285C55.3147 57.6406 55.2997 56.8285 55.8074 56.2969C56.2959 55.8135 57.1049 55.8004 57.6348 56.307L63.0544 61.7266C63.5393 62.2114 63.5571 63.0165 63.0591 63.5482C62.789 63.7921 62.4519 63.9171 62.1264 63.9171Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
